import { DocumentViewerMutationTypes } from './mutation_types'
import { DocumentViewerState } from './state'

export const mutations: StoreMutations<DocumentViewerMutationTypes, DocumentViewerState> = {
  [DocumentViewerMutationTypes.SET_REDACT_DOCUMENT_DIALOG] (state, value) {
    state.redactDocumentDialogIsOpen = value
  },
  [DocumentViewerMutationTypes.SET_REDACT_DOCUMENT_ERROR] (state, value) {
    state.redactDocumentError = value
  },
}
